<template>
  <div class="mit-data-table-crud-client"><!-- default all to 1 but override sm and larger to 8 -->
      <v-data-table
        :headers="headers"
        :items="items"
        sort-by="calories"
        class="elevation-0"
        :items-per-page="-1"
        :search="search.text"
        :mobile-breakpoint="-1"
        :hide-default-header="$vuetify.breakpoint.name === 'xs' && useMobileView()"
      >
        <!-- IMPORTANT - to expose the v-data-table dynamic slots through this component this is needed.
        it will iterate the slots and re-expose them here in this component, so anyone using it can use
        the same slots defined for v-data-table. -->
        <template v-for="field in Object.keys($scopedSlots)" v-slot:[field]="{item}">
           <slot :name="field" :item="item" :search="search"/> <!--Added the search from this component into the slots exposed by v-data-table so consumers can see what current search is when creating templates -->
        </template>

        <!--
        Toolbar - Search
        -->
        <template v-slot:top>
            <v-toolbar flat>
                <slot name="tableHeader" :title="title" :search="search">
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="pr-5 doNotPrint"
                      v-model="search.text"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                </slot>

                <slot name="dialogEdit" v-bind:dialogProps="dialogEdit">
                  <v-dialog v-if="editable" v-model="dialogEdit.show" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" class="mb-2 doNotPrint" v-bind="attrs" v-on="on">New {{itemTitle}}</v-btn>
                    </template>
                    <v-card>
                      <v-card-title><span class="text-h5">{{ formTitle }}</span></v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col v-for="h in headers" :key="h.name" cols="12" sm="12" md="12">
                              <v-text-field v-if="h.edit && typeof (h.edit.type) === 'undefined'" :value="updateByPath(dialogEdit.item, h.value)" @change="eventPropertyChange($event, dialogEdit.item, h.value)" :label="h.text"></v-text-field>
                              <v-select v-if="h.edit && h.edit.type && h.edit.type ==='select-return-object'" :label="h.text" :items="h.edit.types.items" item-text="name" item-value="id" :value="updateByPath(dialogEdit.item, h.edit.path)" @change="eventPropertyChange($event, dialogEdit.item, h.edit.path)" return-object></v-select>
                              <v-select v-if="h.edit && h.edit.type && h.edit.type ==='select'" :label="h.text" :items="h.edit.types.items" item-text="name" item-value="id" :value="updateByPath(dialogEdit.item, h.edit.path)" @change="eventPropertyChange($event, dialogEdit.item, h.edit.path)"></v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialogEdit.close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="dialogEdit.save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </slot>

                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

          </v-toolbar>
        </template>

        <!--
        Mobile View - Header
        -->
        <template v-if="$vuetify.breakpoint.name === 'xs' && useMobileView()" v-slot:header="{ item, props }">
          <thead class="v-data-table-header">
            <tr>
              <th v-for="header in headers" :key="header.text" v-if="header.mobile" scope="col">
                {{ header.text }}
              </th>
              <th scope="col" v-if="showActions()">
                Actions
              </th>
            </tr>
          </thead>
        </template>
        <!--
        Mobile View - row
        -->
        <template v-if="$vuetify.breakpoint.name === 'xs'  && useMobileView()" v-slot:item="{ item }">
          <tr class="v-data-table__mobile-table-row v-data-table__expanded v-data-table__expanded__row">
              <td class="text-start" v-for="header in headers" :key="header.text" v-if="header.mobile" scope="col">

                <slot :name="'item.'+header.value+'-mobile'" :item="item" :search="search">
                  {{ updateByPath(item, header.value) }}
                </slot>
              </td>
              <td class="text-end" v-if="showActions()">
                <v-row>
                  <v-spacer/>
                  <v-btn class="pr-4" icon small @click="editItem(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                  <v-btn icon  small @click="deleteItem(item)"><v-icon>mdi-delete</v-icon></v-btn>
                </v-row>
              </td>
          </tr>
          <tr class="v-data-table__expanded v-data-table__expanded__content">
            <td colspan="3">
              <v-row>
                <v-col class="pl-8" cols="12">
                  <span v-if="typeof header.mobile === 'undefined'" v-for="header in headers" :key="header.text">
                    <slot :name="'item.'+header.value+'-mobile'" :item="item" :search="search">
                      <span>
                        {{header.text}}:
                      </span> {{ updateByPath(item, header.value) }}<br/>
                    </slot>
                  </span>
                </v-col>
              </v-row>
            </td>
          </tr>
        </template>

        <!--
        Desktop View - row
        -->
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <p>No data.</p>
        </template>
      </v-data-table>
  </div>
</template>

<script>

export default {
  name: 'MitDataTableClient',
  components: {},
  props: {
    title:{
      default: "Items",
      type: String
    },
    itemTitle: {
      default: "Item",
      type: String
    },
    headers: Array,
    items:Array,
    editable: {
      default: true,
      type: Boolean
    },
    getNewItem: {
      default: () => {},
      type: Function
    },
    getCopyItem: {
      default: () => {},
      type: Function
    },
    setCopyItem: {
      default: () => {},
      type: Function
    }
  },
  data: function() {
    return {
      //search:'',
      search:{
        text:''
      },
      dialogDelete: false,
      dialogEdit:{ //slot object that can get passed to any slot override so that it has access to necessary data and functions
        show:false,
        item:this.getNewItem(),
        close:this.close,
        save:this.save,
        editedIndex: -1,
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.close()
    },
  },
  computed: {
      formTitle () {
        return this.dialogEdit.editedIndex === -1 ? 'New '+this.itemTitle : 'Edit '+this.itemTitle
      },
  },
  methods: {
      useMobileView(){
        //If any header item has a .mobile property then we will use the mobile view
        for(let x = 0; x < this.headers.length; x++){
          if(this.headers[x].mobile){
            return true
          }
        }
        return false;
      },
      showActions(){
        //Only really needed in custom or mobile views as not including the actions in the header will not display it
        for(let x = 0; x < this.headers.length; x++){
          if(this.headers[x].value === 'actions'){
            return true
          }
        }
        return false;
      },
      //Update or just return the value of the target obj. Deep property get
      updateByPath(obj, path, val) {
        let parts = path.split(".");
        if (parts.length==1){
            if(val) return (obj[parts[0]] = val);
            else return obj[parts[0]];
        }
        return this.updateByPath(obj[parts[0]], parts.slice(1).join("."), val);
      },
      eventPropertyChange(event, item, propery){
        //update the property on the target item
        this.updateByPath(item, propery, event);
      },
      editItem (item) {
        this.dialogEdit.editedIndex = this.items.indexOf(item)

        //this.editedItem = this.getCopyItem(item);
        this.dialogEdit.item = this.getCopyItem(item);
        //this.dialog = true;
        this.dialogEdit.show = true;
        console.log('EDIT CALLED');

      },
      deleteItem (item) {
        this.dialogEdit.editedIndex = this.items.indexOf(item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.$emit('delete',this.items.splice(this.dialogEdit.editedIndex, 1)[0]);
        this.close();
      },
      close () {

        //this.dialog = false;
        this.dialogEdit.show = false;

        this.dialogDelete = false;
        this.$nextTick(() => {
          //this.editedItem = this.getNewItem();
          this.dialogEdit.item = this.getNewItem();
          this.dialogEdit.editedIndex = -1;
        })
      },
      save () {
        //Editing
        if (this.dialogEdit.editedIndex > -1) {
          //this.setCopyItem(this.items[this.dialogEdit.editedIndex], this.editedItem);
          this.setCopyItem(this.items[this.dialogEdit.editedIndex], this.dialogEdit.item);
          this.$emit('edit',this.items[this.dialogEdit.editedIndex]);
        }
        //New
        else {
          // this.items.push(this.editedItem)
          //this.$emit('new',this.editedItem);
          this.items.push(this.dialogEdit.item)
          this.$emit('new',this.dialogEdit.item);
        }

        this.close()
      }
    }
}
</script>

<style lang="scss" scoped>
</style>
